module.exports = __webpack_public_path__ + "src/assets/img/arrow-down.f6e2f09a.svg";